export const AddLensesModalText = {
    Action: "Add Selected",
};
